export function parseMoneyToNumber(value) {
  if (value === null || value === undefined) return null;

  let str = String(value).trim();
  if (!str) return null;

  // 🔹 remove símbolo de moeda e qualquer coisa que não seja número, ponto, vírgula ou sinal
  str = str.replace(/[^\d.,-]/g, "");

  // remove espaços
  str = str.replace(/\s/g, "");

  // Se tiver vírgula e ponto
  if (str.includes(",") && str.includes(".")) {
    // Se a última vírgula vem depois do último ponto → padrão BR 3.300,00
    if (str.lastIndexOf(",") > str.lastIndexOf(".")) {
      str = str.replace(/\./g, "").replace(",", ".");
    } else {
      // padrão US 3,300.00
      str = str.replace(/,/g, "");
    }
  }
  // Só vírgula → assume decimal BR
  else if (str.includes(",")) {
    str = str.replace(",", ".");
  }

  const number = Number(str);

  return Number.isFinite(number) ? number : null;
}

export function parseDecimalNumber(value) {
  if (value === null || value === undefined) return null;

  const str = String(value).trim();
  if (!str) return null;

  // troca vírgula por ponto se vier no padrão BR
  const normalized = str.replace(",", ".");

  const n = Number(normalized);

  return Number.isFinite(n) ? n : null;
}
